import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/Home'
// import Category from '../views/Category'
// import General from '../views/General'
// import Artist from '../views/Artist'
// import Project from '../views/Project'
// import Review from '../views/Review'
import Regulations from '../views/Regulations'
import Contact from '../views/Contact'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: Home
    },
    // {
    //   path: '/submit',
    //   redirect: '/submit/category'
    // },
    // {
    //   path: '/submit/category',
    //   component: Category
    // },
    // {
    //   path: '/submit/general',
    //   component: General
    // },
    // {
    //   path: '/submit/contact',
    //   component: Artist
    // },
    // {
    //   path: '/submit/project',
    //   component: Project
    // },
    // {
    //   path: '/submit/review',
    //   component: Review
    // },
    // {
    //   path: '/submit/*',
    //   redirect: '/submit'
    // },
    {
      path: '/regulations',
      component: Regulations
    },
    {
      path: '/contact',
      component: Contact
    },
    {
      path: '*',
      redirect: '/'
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
